import {Button, Test} from "../../components";
import pic from '../../resources/screen1.jpg';
import {useState} from "react";
import Shuffle from "../../services/Shuffle";
import styles from "../../components/Button/Button.module.scss";

const text = "Сколько раз в песне Клавы Коки «Зая» было использовано слово «УШКО»?",
    arr = [
        {
            name: "3",
            desc: "Опять мимо! Ты слушал песню в оба уха?"
        },
        {
            name: "10",
            desc: "Кажется, ушей в песне гораздо меньше. Попробуй ещё!",
        },
        {
            name: "1",
            desc: "Я шепну тебе на ушко — это верный ответ!",
            answer: true
        },
        {
            name: "4",
            desc: "Ай-ай. Попробуй ещё раз\n"
        }
    ];

export const FirstTest = ({handler}) => {
    const [success, setStep] = useState(false);
    const buttonText = success ? "И это правильный ответ" : "Выберите ответ",
        buttonType = !success ? 'disabled' : 'active';

    return (
        <Test desc={text} arr={Shuffle(arr)} pic={pic} handler={setStep} className={"success-reg"}>
            <Button id="button-test-1" className={styles.mobile} text={buttonText} handler={success ? handler : () => null} type={buttonType}/>
        </Test>
    )
}